import { createSlice } from '@reduxjs/toolkit';
import { fetchDocumentApprovalsByCommunityId } from './ApprovalsApi';

const fetchDocumentApprovalsByCommunityIdSlice = createSlice({
    name: 'fetchDocumentApprovalsByCommunityId',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchCommunityData cases
            .addCase(fetchDocumentApprovalsByCommunityId.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDocumentApprovalsByCommunityId.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchDocumentApprovalsByCommunityId.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default fetchDocumentApprovalsByCommunityIdSlice.reducer;
